import { useMemo } from 'react';
import appBranding from '@happylife-a/branding';
import enums from '@happylife-a/enums';
import utils from '@happylife-a/utils';
import webApp from '@happylife-a/web-app';
import webCore from '@happylife-a/web-core';

export default function useGetGrantMenuItem() {
  const { data, isLoading } = webCore.coreHooks.grant.useGetGrantStatus();
  const { isLegalCustomer } = webCore.contexts.useUser();

  return useMemo(() => {
    if (!isLegalCustomer || !appBranding.tools.features.isEnabled('LegalCustomerGrant')) {
      return [];
    }

    let name = 'Request a Grant';
    if (isLoading) {
      name = 'Loading';
    }

    switch (data?.status) {
      case enums.grant.CustomerGrantStatusTypeEnum.Pending:
        name = 'Grant is requested';
        break;
      case enums.grant.CustomerGrantStatusTypeEnum.Confirmed:
        if (data?.confirmedAmount) {
          name = utils.helpers.currency.beautify(data?.confirmedAmount);
        }
        break;
    }

    return [
      {
        name: name,
        link: '/request-grant',
        icon: webApp.theme.icons.CupIcon,
      },
    ];
  }, [data, isLoading, isLegalCustomer]);
}
